import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpHeader のスタイル
 */
export const hotlineLpHeaderStyle = tv({
    slots: {
        arrowIcon: ['text-[#4881F1] lg:hidden'],
        base: [
            'px-20 sm:px-32 xl:px-[64px] pt-52 sm:pt-44 pb-20',
            'flex justify-between items-center gap-x-12',
            'fixed w-full top-0 z-[999] lg:z-[998]',
            'transition-all duration-500',
        ],
        hamburgerBackground: ['lg:hidden'],
        hamburgerButton: [
            'lg:hidden',
            'text-[26px]',
            'size-[41px]',
            'rounded-full',
            'flex items-center justify-center',
            'border-solid border border-[#4881F1]',
            'shrink-0',
        ],
        imageLink: ['inline-flex'],
        logo: ['w-[216px] lg:w-[270px]'],
        navItem: [
            'text-[16px] font-bold leading-[23px] text-[#231916]',
            'max-lg:p-[20px]',
            'block w-full',
            'max-lg:items-center max-lg:justify-between max-lg:flex',
            'max-lg:border-0 max-lg:border-b max-lg:border-solid max-lg:border-[#D8E6FA]',
        ],
        navItemButton: ['max-lg:text-center'],
        navUlWrapper: [
            'max-lg:h-dvh max-lg:w-full max-lg:max-w-[400px]',
            'max-lg:bg-[#FFFFFF]',
            'pt-[113px] sm:pt-[105px] lg:pt-0',
            'fixed right-0 lg:right-[32px] xl:right-[64px] top-0 lg:top-[40px]',
            'transition-opacity duration-500',
            'z-[998] lg:z-[999]',
            'lg:flex lg:gap-x-24 xl:gap-x-32 lg:items-center',
        ],
    },
    variants: {
        hamburgerShow: {
            false: {
                hamburgerBackground: 'hidden',
                hamburgerButton: 'text-[#4881F1] bg-[#FFFFFF]',
                navUlWrapper: 'max-lg:opacity-0 max-lg:-z-10',
            },
            true: {
                base: 'bg-[#FFFFFF] shadow-[2px_2px_8px_2px_#D6EFFF]',
                hamburgerBackground: 'fixed right-0 z-[997] flex h-screen w-screen bg-black overscroll-contain overflow-y-scroll opacity-50',
                hamburgerButton: 'bg-[#4881F1]',
                navUlWrapper: 'max-lg:opacity-100',
                spHeader: 'bg-[#FFFFFF] shadow-[2px_2px_8px_2px_#D6EFFF]',
            },
        },
        isScrolled: {
            false: {
                base: '',
            },
            true: {
                base: 'bg-[#FFFFFF] shadow-[2px_2px_8px_2px_#D6EFFF]',
            },
        },
    },
});
